import types from '../actions/types';

const initialState = { };

const cleanableState = {
  paymentType: 'red',
  installments: { value: 1, label: 'CONTADO' },

  paymentNumber: null,
  creditCardNumber: '',
  creditCardDueDate: '',
  confidenceBroker: null,
  acceptTermConditions: false,
  purchaseResult: null,
  newPolicy: null,

  errorMessage: '',
  openSiemprePago: false
};

const payment = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN:
      return { ...state, ...cleanableState};
      
    case types.CLEAN_INSTALLMENTS:
      return { ...state, installments: { value: 1, label: 'CONTADO' } };

    case types.SET_INSTALLMENTS:
      return {
        ...state,
        installments: action.payload,
        openSiemprePago: false
      };

    case types.SET_PAYMENT_VALUE: {
      const { type, value } = action.payload;
      return {
        ...state,
        [type]: value
      }
    };

    case types.TOGGLE_TERMS_CHECK: {
      return {
        ...state,
        acceptTermConditions: !state.acceptTermConditions
      }
    };

    default:
      return state;
  }
};

export default payment;
